<template>
  <div
    class="collapse navbar-collapse w-auto h-auto h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
  <!-- Dashboard (manteniendo como entrada principal, ya que es común en menús) -->
  <li class="nav-item">
    <sidenav-item
      url="/dashboard-default"
      :class="getRoute() === 'dashboard-default' ? 'active' : ''"
      :navText="this.$store.state.isRTL ? 'لوحة القيادة' : 'Dashboard'"
    >
      <template v-slot:icon>
        <i class="fa fa-columns text-success text-sm opacity-10"></i>
      </template>
    </sidenav-item>
  </li>

  <!-- Sección Fracturación -->
  <li class="mt-3 nav-item">
    <h6
      v-if="this.$store.state.isRTL"
      class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
      :class="this.$store.state.isRTL ? 'me-4' : 'ms-2'"
    >
      صفحات المرافق
    </h6>
    <h6
      v-else
      class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
      :class="this.$store.state.isRTL ? 'me-4' : 'ms-2'"
    >
      Fracturación
    </h6>
  </li>
  <li class="nav-item">
    <sidenav-item
      url="/clients"
      :class="getRoute() === 'clients' ? 'active' : ''"
      :navText="this.$store.state.isRTL ? 'العملاء' : 'Clientes'"
    >
      <template v-slot:icon>
        <i class="fa fa-users text-success text-sm opacity-10"></i>
      </template>
    </sidenav-item>
  </li>
  <li class="nav-item">
    <sidenav-item
      url="/invoices"
      :class="getRoute() === 'facturacion' ? 'active' : ''"
      :navText="this.$store.state.isRTL ? 'الفواتير' : 'Facturación'"
    >
      <template v-slot:icon>
        <i class="fa fa-receipt text-success text-sm opacity-10"></i>
      </template>
    </sidenav-item>
  </li>
  <li class="nav-item">
    <sidenav-item
      url="/billing-reports"
      :class="getRoute() === 'billing-reports' ? 'active' : ''"
      :navText="this.$store.state.isRTL ? 'التقارير' : 'Reportes'"
    >
      <template v-slot:icon>
        <i class="fa fa-chart-bar text-success text-sm opacity-10"></i>
      </template>
    </sidenav-item>
  </li>

  <!-- Sección Inventario -->
  <li class="mt-3 nav-item">
    <h6
      v-if="this.$store.state.isRTL"
      class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
      :class="this.$store.state.isRTL ? 'me-4' : 'ms-2'"
    >
      صفحات المرافق
    </h6>
    <h6
      v-else
      class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
      :class="this.$store.state.isRTL ? 'me-4' : 'ms-2'"
    >
      Inventario
    </h6>
  </li>
  <li class="nav-item">
    <sidenav-item
      url="/suppliers"
      :class="getRoute() === 'suppliers' ? 'active' : ''"
      :navText="this.$store.state.isRTL ? 'الموردين' : 'Proveedores'"
    >
      <template v-slot:icon>
        <i class="fa fa-truck text-success text-sm opacity-10"></i>
      </template>
    </sidenav-item>
  </li>
  <li class="nav-item">
    <sidenav-item
      url="/products"
      :class="getRoute() === 'products' ? 'active' : ''"
      :navText="this.$store.state.isRTL ? 'المنتجات' : 'Productos'"
    >
      <template v-slot:icon>
        <i class="fa fa-box text-success text-sm opacity-10"></i>
      </template>
    </sidenav-item>
  </li>
  <li class="nav-item">
    <sidenav-item
      url="/routes"
      :class="getRoute() === 'routes' ? 'active' : ''"
      :navText="this.$store.state.isRTL ? 'الطرق' : 'Rutas'"
    >
      <template v-slot:icon>
        <i class="fa fa-route text-success text-sm opacity-10"></i>
      </template>
    </sidenav-item>
  </li>
  <li class="nav-item">
    <sidenav-item
      url="/purchases"
      :class="getRoute() === 'purchases' ? 'active' : ''"
      :navText="this.$store.state.isRTL ? 'المشتريات' : 'Compras'"
    >
      <template v-slot:icon>
        <i class="fa fa-shopping-cart text-success text-sm opacity-10"></i>
      </template>
    </sidenav-item>
  </li>
  <li class="nav-item">
    <sidenav-item
      url="/outflows"
      :class="getRoute() === 'outflows' ? 'active' : ''"
      :navText="this.$store.state.isRTL ? 'المخرجات' : 'Salidas'"
    >
      <template v-slot:icon>
        <i class="fa fa-share-square text-success text-sm opacity-10"></i>
      </template>
    </sidenav-item>
  </li>
  <li class="nav-item">
    <sidenav-item
      url="/inventory-reports"
      :class="getRoute() === 'inventory-reports' ? 'active' : ''"
      :navText="this.$store.state.isRTL ? 'التقارير' : 'Reportes'"
    >
      <template v-slot:icon>
        <i class="fa fa-file-alt text-success text-sm opacity-10"></i>
      </template>
    </sidenav-item>
  </li>

  <!-- Opcional: Sección de Configuraciones (puedes agregar si es necesario, pero no se mencionó en la solicitud) -->
  <!-- Si no lo necesitas, elimínalo -->
</ul>
  </div>
  <div class="pt-3 mx-3 mt-3 sidenav-footer">
    <sidenav-card
      :class="cardBg"
      textPrimary="Need Help?"
      textSecondary="Please check our docs"
    />
  </div>
</template>
<script>
import SidenavItem from "./SidenavItem.vue";
import SidenavCard from "./SidenavCard.vue";

export default {
  name: "SidenavList",
  props: {
    cardBg: String
  },
  data() {
    return {
      title: "Argon Dashboard 2",
      controls: "dashboardsExamples",
      isActive: "active"
    };
  },
  components: {
    SidenavItem,
    SidenavCard
  },
  methods: {
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    }
  }
};
</script>
